export const openPrivacyHtml = () => {};
